const protocolColumn = {title: 'PROTOCOLO', att: 'protocolCode'};
const createdByColumn = {title: 'CREADA POR', att: 'createdBy'};

const getDeleteActionColumn = (deleteAction) => ({
    renderCell: deleteAction,
    align: 'center',
    sortable: false,
    flex: 0.5,
});

const getProviderUserColumns = ({attention, date, affiliate, deleteAction}) => [
    {title: 'NOMBRE', att: 'name'},
    protocolColumn,
    {
        title: 'ATENCIÓN',
        att: 'medicalServiceName',
        flex: 2,
        renderCell: attention,
    },
    {title: 'FECHA', att: 'createdDate', renderCell: date},
    {title: 'MODALIDAD', att: 'modality'},
    {title: 'AFILIADO', att: 'affiliateFullName', renderCell: affiliate},
    {title: 'PLAN', att: 'planName'},
    createdByColumn,
    getDeleteActionColumn(deleteAction),
];

const getProviderAdminColumns = ({attention, date, affiliate, deleteAction}) => [
    {title: 'NOMBRE', att: 'name'},
    protocolColumn,
    {title: 'ATENCIÓN', att: 'medicalServiceName', renderCell: attention},
    {title: 'FECHA', att: 'createdDate', renderCell: date},
    {title: 'MODALIDAD', att: 'modality'},
    {title: 'MONTO', att: 'amountPaid'},
    {title: 'AFILIADO', att: 'affiliateFullName', renderCell: affiliate},
    {title: 'SEDE', att: 'branchAddress'},
    {title: 'PLAN', att: 'planName'},
    createdByColumn,
    getDeleteActionColumn(deleteAction),
];

const getAdminColumns = ({attention, date, affiliate, deleteAction}) => [
    {title: 'NOMBRE', att: 'name'},
    protocolColumn,
    {title: 'ATENCIÓN', att: 'medicalServiceName', renderCell: attention},
    {title: 'FECHA', att: 'createdDate', renderCell: date},
    {title: 'MODALIDAD', att: 'modality'},
    {title: 'MONTO', att: 'amountPaid'},
    {title: 'AFILIADO', att: 'affiliateFullName', renderCell: affiliate},
    {title: 'PRESTADOR', att: 'providerName'},
    {title: 'SEDE', att: 'branchAddress'},
    {title: 'PLAN', att: 'planName'},
    createdByColumn,
    getDeleteActionColumn(deleteAction),
];

export const getAttentionHistoryColumns = (role, renderers) => {
    switch (role) {
        case 'ADMIN':
            return getAdminColumns(renderers);
        case 'PROVIDER_ADMIN':
            return getProviderAdminColumns(renderers);
        case 'PROVIDER_USER':
        case 'PROVIDER_USER_QUOTER':
        case 'PROVIDER_USER_VIEWER':
        default:
            return getProviderUserColumns(renderers);
    }
};
